import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, MapPin, Clock, Mail } from 'lucide-react';
import { BUSINESS_INFO, SERVICES, SERVICE_AREAS } from '@/lib/constants';

const Footer = () => {
    const currentYear = new Date().getFullYear();

    return (
        <footer className="bg-foreground text-background">
            {/* Main Footer */}
            <div className="container-custom section-padding">
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-12">
                    {/* Company Info */}
                    <div className="lg:col-span-1">
                        <Link to="/" className="flex items-center gap-3 mb-6">
                            <div className="flex items-center justify-center w-12 h-12 rounded-xl bg-primary text-primary-foreground font-bold text-xl font-heading">
                                AT
                            </div>
                            <div className="flex flex-col">
                                <span className="font-heading font-bold text-xl">
                                    <span className="text-[hsl(45_90%_55%)]">Altın</span>{' '}
                                    <span className="text-background">Teknik</span>
                                </span>
                                <span className="text-sm text-background/70">
                                    {BUSINESS_INFO.tagline}
                                </span>
                            </div>
                        </Link>
                        <p className="text-background/70 text-sm leading-relaxed mb-6">
                            Antalya'da klima satış, montaj, bakım ve onarım hizmetlerinde 
                            güvenilir çözüm ortağınız. Tüm klima markalarında profesyonel servis.
                        </p>
                    </div>

                    {/* Services */}
                    <div>
                        <h3 className="font-heading font-semibold text-lg mb-5">Hizmetlerimiz</h3>
                        <ul className="space-y-3">
                            {SERVICES.slice(0, 6).map((service) => (
                                <li key={service.id}>
                                    <Link 
                                        to="/hizmetler" 
                                        className="text-background/70 hover:text-primary transition-colors text-sm"
                                    >
                                        {service.title}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </div>

                    {/* Service Areas */}
                    <div>
                        <h3 className="font-heading font-semibold text-lg mb-5">Hizmet Bölgeleri</h3>
                        <ul className="grid grid-cols-2 gap-2">
                            {SERVICE_AREAS.map((area) => (
                                <li key={area}>
                                    <span className="text-background/70 text-sm">{area}</span>
                                </li>
                            ))}
                        </ul>
                    </div>

                    {/* Contact Info */}
                    <div>
                        <h3 className="font-heading font-semibold text-lg mb-5">İletişim</h3>
                        <ul className="space-y-4">
                            <li>
                                <a 
                                    href={`tel:${BUSINESS_INFO.phone}`}
                                    className="flex items-start gap-3 text-background/70 hover:text-primary transition-colors"
                                >
                                    <Phone className="h-5 w-5 shrink-0 mt-0.5" />
                                    <span className="text-sm">{BUSINESS_INFO.phoneDisplay}</span>
                                </a>
                            </li>
                            <li>
                                <a 
                                    href={BUSINESS_INFO.googleMapsUrl}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="flex items-start gap-3 text-background/70 hover:text-primary transition-colors"
                                >
                                    <MapPin className="h-5 w-5 shrink-0 mt-0.5" />
                                    <span className="text-sm">{BUSINESS_INFO.addressShort}</span>
                                </a>
                            </li>
                            <li>
                                <div className="flex items-start gap-3 text-background/70">
                                    <Clock className="h-5 w-5 shrink-0 mt-0.5" />
                                    <div className="text-sm">
                                        <p>Pzt-Cmt: {BUSINESS_INFO.workingHours.weekdays}</p>
                                        <p>Pazar: {BUSINESS_INFO.workingHours.sunday}</p>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>

            {/* Bottom Bar */}
            <div className="border-t border-background/10">
                <div className="container-custom py-6">
                    <div className="flex flex-col md:flex-row items-center justify-between gap-4 text-sm text-background/60">
                        <p>© {currentYear} {BUSINESS_INFO.name}. Tüm hakları saklıdır.</p>
                        <div className="flex items-center gap-6">
                            <Link to="/" className="hover:text-primary transition-colors">Ana Sayfa</Link>
                            <Link to="/hizmetler" className="hover:text-primary transition-colors">Hizmetler</Link>
                            <Link to="/iletisim" className="hover:text-primary transition-colors">İletişim</Link>
                        </div>
                    </div>
                </div>
            </div>

            {/* Pastel Credit */}
            <div className="bg-foreground border-t border-background/5">
                <div className="container-custom py-4">
                    <div className="flex items-center justify-center gap-3 text-xs text-background/50">
                        <img 
                            src="https://customer-assets.emergentagent.com/job_altin-hvac/artifacts/a4zx2vi4_Pastel%20Logo.PNG" 
                            alt="Pastel Logo" 
                            className="h-5 w-auto opacity-70"
                        />
                        <span>Pastel Web Yazılım Tüm Hakları Saklıdır.</span>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
